import React, { useEffect, useState } from "react";
import { IconButton } from "@mui/material";
import { Check, MapPin } from "lucide-react";
import closeModal from "../../assets/images/closeModal.svg";
import "../DesignationLevel/DynamicModal.css";
import TextField from "../designSystem/TextField";
import CancelButton from "../subComponents/buttons/CustomCancelButton";
import PrimaryButton from "../subComponents/buttons/PrimaryButton";
import LoadingOverlay from "../loadingOverlay/LoadingOverlay";
import fuelService from "../../services/fuel.service";
import { t } from "../../locales/translate";
const EditOutOfBoundRadiusModal = ({ onClose, editData, onSave }) => {
  const [radius, setRadius] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (editData?.radius != null) {
      setRadius(String(editData.radius));
    }
  }, [editData]);

  const handleSave = async (e) => {
    e.preventDefault();
    const parsed = parseFloat(radius);
    if (!radius || Number.isNaN(parsed) || parsed <= 0) {
      setError(t("invalidOutOfBoundRadius"));
      return;
    }
    setError("");
    setLoading(true);
    try {
      const response = await fuelService.saveOutOfBoundRadius({
        radius: parsed,
      });
      if (response.data?.status) {
        onSave(response.data.result?.[0] ?? { radius: parsed });
      }
    } catch (err) {
      console.error("Error saving out of bound radius:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="dynamicmodal-overlay">
      <div className="dynamicmodal-container overlay-wrapper">
        <LoadingOverlay isVisible={loading} />
        <div className={loading ? "blur" : ""}>
          <div className="dynamicmodal-header mb-3">
            <div className="dynamicmodal-header-left">
                <div className="icon fuel-modal-icon" id="fuel-modal-icon">
                <MapPin color="white" size={24} />
                </div>
              <div className="text">
                <h2 className="modalheading">{t("editOutOfBoundRadius")}</h2>
              </div>
            </div>
            <div className="dynamicmodal-header-right">
              <IconButton onClick={onClose}>
                <img src={closeModal} alt="" />
              </IconButton>
            </div>
          </div>

          <form onSubmit={handleSave}>
            <div className="dynamicmodal-body">
              <TextField
                name="radius"
                label={`${t("radiusInMeters")} *`}
                type="number"
                value={radius}
                onChange={(e) => {
                  const val = e.target.value;
                  if (val === "" || parseFloat(val) >= 0) {
                    setRadius(val);
                  }
                }}
                placeholder={t("input")}
                error={error}
              />
            </div>
            <div className="dynamicmodal-footer">
              <CancelButton onClick={onClose} text={t("cancel")} />
              <PrimaryButton text={t("save")} icon={Check} />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditOutOfBoundRadiusModal;
